import { Component, OnInit, Output, EventEmitter, trigger, AfterViewInit,
  state,
  style,
  animate,
  transition,
  keyframes } from '@angular/core';

import { UserService } from "../../../injections/user.service";
import { ModalEmailService } from "../../../common/modal-email/modal-email.service";
import { LoaderService } from "../../../common/loadingBar/loader.service";
import { ActivatedRoute } from "@angular/router";
import { ServiceService } from '../../../injections/service.service';
import * as moment from 'moment';

@Component({
    moduleId: module.id,
    selector: 'main-user',
    templateUrl: '../templates/main-user.html',
    animations: [
    trigger('showCreatOffice', [
            state('inactive', style({
                display: 'none',
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('active', style({
                display: 'block',
                "max-height": '4000px',

            })),
            transition('inactive => active', animate('300ms ease-in')),
            transition('active => inactive', animate('300ms ease-out'))
        ]),

    ],
    providers: [UserService],
})

export class MainUserComponent implements OnInit {
    private sub: any;
    public showModal = false;
    public showModalDisclaimer = false;
    public showModalBill = false;
    public addresses: Array<object> = [];
    public cities: Array<object> = [];
    public services: Object = {};
    public modalData;
    public data;
    public cleaners;
    public dataAddressModal;
    public dataDisclaimerModal;
    public serviceBill;
    public mgmCode;
    private id: string;
    constructor(
        private userService: UserService, 
        private route: ActivatedRoute, 
        private _loader: LoaderService, 
        private modalEmailService: ModalEmailService,
        private serviceService: ServiceService
    ) { 
        this.route.params.subscribe(params => {
          this.id = params["id"];
        });

         this.userService.getUserData(this.id).subscribe(response => {
                this.addresses = response["addresses"];
                this.data = response;
                this.cleaners = response["cleaners"];
                this.cleaners["id"] = this.id;
            },
            error => {
                console.log(error);
            }
        );
        this.userService.loginApi().subscribe(result =>{
            //console.log(result);
            this.userService.getClientInfo(this.id, result.token).subscribe(result => {
                //console.log(result);
                this.mgmCode = result.client.mgmCode;
            });
        })

        this.userService.getFutureServices(this.id).subscribe(response => {
            //console.log(response);
            this.services["future"] = response;
            },
            error => {
                console.log(error);
            }
        );

        this.userService.getHistoryServices(this.id).subscribe(response => {
            //console.log(response);
            this.services["history"] = response;
            },
            error => {
                console.log(error);
            }
        );


        this.cities = this.userService.getAvailableCities();
    }

   public displayModal(event):void {
        this.modalData = event;
        this.showModal = (event == "close") ? false : true;
    }

    public displayModalAddress(event: any) {
        if(event["action"] != "close"){
            this.showModal = true;
            this.dataAddressModal = event;

        }else{
            if(event["data"] != null){
                this.saveAddress(event["data"], event["type"]);
            }
            this.showModal = false;
        }

    }

    public displayModalBill($event: any) {
        this.showModalBill = true;
        this.serviceService.getServiceById($event["id_service"]).subscribe(result => {
            result["service"]["today"] = moment(result["service"]["today"],"YYYY-MM-DD").format("DD/MM/YYYY")
            result["service"]["id_service"] = $event["id_service"];
            this.serviceBill = result; 
        });
    }

    public hideModalBill($event) {
        this.showModalBill = false;
    }

    public displayModalDisclaimerMail(event: any) {
        if(event["action"] != "close"){
            this.showModalDisclaimer = true;
            this.dataDisclaimerModal = event;
        }else{
            this.showModalDisclaimer = false;
            if(event["data"] != null) {
                this.sendLinkCard();
            }
        }
    }

    public sendLinkCard() {
        this.userService.sendLinkUpdateCard(this.id).subscribe( status => {
            console.log(status);
        });
    }

    public saveAddress(data: object, type: string) {
        if(type == "add"){
            this.userService.createNewAddress(this.id, data).subscribe( result => {
                //console.log(result);
                data["id_address"] = result["response"]["insertId"];
                data["id_client"] = this.id;
                this.addresses.push(data);
            })
        }else if(type == "remove"){
            this.userService.deleteAddress(this.id, data["id_address"]).subscribe( result => {
                //console.log(result);
                if(result["status"] == "OK"){
                    this.addresses.splice(data["index"],1);
                }
            })
        }else if(type == "edit") {
            this.userService.updateAddress(this.id, data["id_address"], data).subscribe( result =>{
                //console.log(result)
                if(result["status"] == "OK"){
                    data["id_client"] = this.id;
                    this.addresses[data["index"]] = data;
                }
            });
        }
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/main-user.component.ts